import { useState } from 'react';
import { Box, Divider, Link, List, ListItem, OnDesktop, OnMobile, Popover } from '@hopskipdrive/react-components';
import { ActionBar, ButtonLink } from '@rideiq/shared/components';
import { Button } from '@rideiq/shared/components/Button';

import { useAuthQuery } from '../../../auth/hooks/useAuthQuery';
import { actions, Can, subjects } from '../../../contexts/AbilityContext';
import { RidesListToggle } from '../../components/RidesListToggle';

import { ButtonsContainer } from './styles';

export const RidesHeader = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLAnchorElement | null>(null);
  const open = Boolean(anchorEl);
  const { enableOnsiteStaff } = useAuthQuery();

  return (
    <ActionBar>
      {enableOnsiteStaff ? (
        <ActionBar.Title
          title={
            <Box display="flex" alignItems="baseline" gap="12px">
              <RidesListToggle title="Rides" currentToggleValue="all_rides" />
            </Box>
          }
        />
      ) : (
        <ActionBar.Title title="Rides" />
      )}

      <ActionBar.SideControls>
        <Can I={actions.add} a={subjects.ride}>
          <ButtonsContainer>
            <OnDesktop>
              <ButtonLink variant="contained" color="secondary" size="large" to="/rides/new">
                Create Ride
              </ButtonLink>
              <ButtonLink variant="contained" color="primary" size="large" to="/rideseries/new">
                Create Ride Series
              </ButtonLink>
            </OnDesktop>
            <OnMobile>
              <Link variant="overline" color="primary" onClick={(e) => setAnchorEl(e.currentTarget)}>
                <Button variant="contained" color="secondary" size="medium" style={{ padding: '6px 12px' }}>
                  Create...
                </Button>
              </Link>
              <Popover
                sx={{
                  '.MuiPopover-paper': {
                    overflow: 'visible',
                    borderRadius: '20px',
                  },
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <List data-testid="rides-list-dropdown">
                  <ListItem>
                    <ButtonLink
                      variant="contained"
                      color="secondary"
                      size="medium"
                      style={{ padding: '6px 12px' }}
                      to="/rides/new"
                    >
                      Create Ride
                    </ButtonLink>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ButtonLink
                      variant="contained"
                      color="primary"
                      size="medium"
                      style={{ padding: '6px 12px' }}
                      to="/rideseries/new"
                    >
                      Create Ride Series
                    </ButtonLink>
                  </ListItem>
                </List>
              </Popover>
            </OnMobile>
          </ButtonsContainer>
        </Can>
      </ActionBar.SideControls>
    </ActionBar>
  );
};
